/**
 * 公共接口
 */
import http from '../http';
import Qs from 'qs';

// 登录
const handelLogin = params =>
  http.post('/login', Qs.stringify(params)).then(res => res.data);

// 登录之前
const handelLoginNew = params =>
  http.get('/user/account', { params }).then(res => res.data);
// 登录
const loginTrue = params =>
  http.post('/login/extend', Qs.stringify(params)).then(res => res.data);
// // 获取图片验证码信息 v1.3.1废除
// const getImageCode = params =>
//   http.get('/credentialPre/captcha/image', { params }).then(res => res.data);
// 获取图片验证码信息
const getImageCodeNew = params =>
  http.get('/user/captcha', { params }).then(res => res.data);

// 切换登录
const postReloginApi = params =>
  http.get('/user/reLogin', { params }).then(res => res.data);
// const postReloginApi = params =>
//   http.post('/user/reLogin', Qs.stringify(params)).then(res => res.data);

// const postReloginApi = (params) =>
//   http({
//     method: 'post',
//     url: `/user/login`,
//     data: params,
//     headers: { 'Content-Type': 'application/json' }
//   }).then((res) => res.data);

export default {
  handelLogin,
  // getImageCode,
  handelLoginNew,
  loginTrue,
  getImageCodeNew,
  postReloginApi
};
